import { render, staticRenderFns } from "./AuditDetail.vue?vue&type=template&id=453e20c9&scoped=true"
import script from "./AuditDetail.vue?vue&type=script&lang=js"
export * from "./AuditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e20c9",
  null
  
)

export default component.exports